import { type Dispatch, type SetStateAction, useLayoutEffect } from 'react';
import { useToast } from './toast';

type MsgSetter = Dispatch<SetStateAction<string | null>>;

function resolveKind(message: string): 'success' | 'error' | 'warning' | 'info' {
  if (/(失败|错误|异常)/.test(message)) return 'error';
  if (/(过期|不正确|不足|不可|无法|无效|限制|确认|请)/.test(message)) return 'warning';
  if (/(成功|已|完成|恢复|发送|保存|删除|撤销|解锁|更新|重置|提交)/.test(message)) return 'success';
  return 'info';
}

export function useMessageToast(msg: string | null, setMsg: MsgSetter, scope: string) {
  const toast = useToast();

  useLayoutEffect(() => {
    const text = String(msg || '').trim();
    if (!text) return;
    const kind = resolveKind(text);
    toast.show(kind, text, { dedupeKey: `${scope}:${text}` });
    setMsg(null);
  }, [msg, scope, setMsg, toast]);
}
